export default {
  sisco_dashboard: '/admin/dashboard',
  error: '/error',
  sisco_error403: '/forbidden',
  sisco_error404: '*'
};
